module.exports = __webpack_public_path__ + "img/bj_4.7ad88c59.jpg";